// Small formatting helpers shared across the admin invoice pages.
//
// Invoice amounts are stored in cents (integer). Divide by 100 before display.

const eurFormatter = new Intl.NumberFormat('es-ES', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2
})

export const formatEuros = (cents, { currency = 'EUR' } = {}) => {
  const n = Number(cents)
  if (!Number.isFinite(n)) return '—'
  const euros = n / 100
  if (currency.toUpperCase() === 'EUR') return eurFormatter.format(euros)
  return new Intl.NumberFormat('es-ES', { style: 'currency', currency }).format(euros)
}

const dateFormatter = new Intl.DateTimeFormat('es-ES', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
})

export const formatDate = (value) => {
  if (!value) return '—'
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return dateFormatter.format(date)
}

export const formatDateTime = (value) => {
  if (!value) return '—'
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return `${dateFormatter.format(date)} ${date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}`
}

// Truncate long hashes for table display: "abc123…def789" (12 chars).
export const truncateHash = (hash) => {
  if (!hash || typeof hash !== 'string') return '—'
  if (hash.length <= 14) return hash
  return `${hash.slice(0, 6)}…${hash.slice(-6)}`
}

export const INVOICE_STATUS_LABELS = {
  draft: 'Borrador',
  issued: 'Emitida',
  void: 'Anulada'
}

export const ALERT_TYPE_LABELS = {
  refund_on_invoiced_payment: 'Refund sobre factura',
  invoice_emission_failed: 'Emisión fallida',
  pdf_generation_failed: 'PDF fallido',
  email_delivery_failed: 'Envío email fallido'
}

export const ALERT_STATUS_LABELS = {
  pending: 'Pendiente',
  acknowledged: 'En revisión',
  resolved: 'Resuelta',
  dismissed: 'Descartada'
}
